module.exports = __webpack_public_path__ + "static/media/okta-phone.cd194b5b.svg";